import React from 'react';
const IncidentWarning = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      opacity="0.4"
      cx="8"
      cy="8"
      r="8"
      fill="#CB2C2C"
      fillOpacity="0.4"
    />
    <circle cx="8.00014" cy="8.00112" r="4.57143" fill="#CB2C2C" />
  </svg>
);

export default IncidentWarning;
